import apiHttp from './apiHttp';
import apiLogin from './apiLogin';
import request from './axiosFun';
// 根据用户id，项目id 查询用户开通项目
var url = '';
if (process.env.NODE_ENV === 'development') {
  url = '/est';
} else {
  url = '';
}
// 个人权限
export function useryangfengquanxian(query) {
  return request({
    url: url + '/livestock/beefarminfo/isFarmManager',
    method: 'post',
    data: query
  });
}
// 蜂箱设备
export function beekUserInfo(query){
  return request({
    url: url + '/livestock/hiveinfo/pageHiveInfo',
    method: 'post',
    data: query
  });
}
// 蜂场管理
export function beekfengch(query) {
  return request({
    url: url + '/livestock/beefarminfo/pageFarmInfo',
    method: 'post',
    data: query
  });
}
// 统计
export function monitor(query) {
  return request({
    url: url + '/livestock/hivehistory/monitor',
    method: 'post',
    data: query
  });
}
// 首页统计数字
export function statistics(query) {
  return request({
    url: url + '/livestock/hiveinfo/getFarmStatistics',
    method: 'post',
    data: query
  });
}

//预警类型统计
export function warningtype(query) {
  return request({
    url: url + '/livestock/thresholdinfo/getCountByWarnType',
    method: 'post',
    data: query
  });
}

//预警列表
export function warninglist(query) {
  return request({
    url: url + '/livestock/thresholdinfo/pageBeeThresholdInfoPC',
    method: 'post',
    data: query
  });
}

//7日总重量趋势
export function zhonglianglist(query) {
  return request({
    url: url + '/livestock/hivehistory/getSevenTotalWeightInfo',
    method: 'post',
    data: query
  });
}



// WEBPACK FOOTER //
// ./src/api/beekeeping.js